module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/desenrola1x-6ca96c529a409a6774a7287f41f7eac8.webp";